// 获取url参数
export const GetQueryString = (name) => {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r;
  if (window.location.search == '') {
    if (window.location.hash != "" && window.location.hash != "#/") {
      r = window.location.hash.split("?")[1].match(reg);
    }
  } else {
    r = window.location.search.substr(1).match(reg); //获取url中"?"符后的字符串并正则匹配
  }
  // console.log(r)
  var context = "";
  if (r != null) context = decodeURIComponent(r[2]);
  reg = null;
  r = null;
  return context == null || context == "" || context == "undefined"
    ? ""
    : context;
};

// 判断平台-微信/支付宝/其他
export const judgePlateFrom = () => {
  if (/AlipayClient/.test(window.navigator.userAgent)) {
    //判断是否是支付宝浏览器打开
    console.log("支付宝客户端");
    return "alipay";
  }

  if (/MicroMessenger/.test(window.navigator.userAgent)) {
    console.log("微信浏览器");
    return "wechat";
  }

  return "undefined";
};

// 判断平台-电脑环境
export const isDesktopEnvironment = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  const ua = navigator.userAgent;

  // 是否触摸设备
  const hasTouch = navigator.maxTouchPoints > 1;

  // iPhone / Android 手机
  const isMobile = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(ua);

  // iPad / Android 平板 / iPadOS(mac伪装)
  const isTablet =
    /iPad|Tablet/i.test(ua) ||
    (
      ua.includes('Macintosh') &&
      hasTouch
    ) ||
    (
      hasTouch &&
      window.innerWidth >= 768 &&
      window.innerWidth <= 1366
    );

  // 真正桌面 Mac
  const isMacDesktop =
    /Macintosh|Mac OS/i.test(ua) &&
    !hasTouch;

  // Windows / Linux
  const isDesktopOS =
    /Windows NT|X11|Linux/i.test(ua);

  return isMacDesktop || isDesktopOS || (!isMobile && !isTablet);
};


// 判断平台
export const isWechat = () => {
  //是否是微信浏览器
  if (/(micromessenger)/i.test(navigator.userAgent)) {
    //是否电脑微信或者微信开发者工具
    if (/(WindowsWechat)/i.test(navigator.userAgent) || /(wechatdevtools)/i.test(navigator.userAgent)) {
      return true;
    } else {
      //手机微信打开的浏览器
      return true;
    }
  } else {
    return false;
  }
};

// 判断是否ios机型
export const checkDevice = () => {
  const ua = window.navigator.userAgent;

  const ios =
    /iPad|iPhone|iPod/i.test(ua);

  const ipadOS =
    ua.includes("Mac")

  return ios || ipadOS;
};

// 判断是否webapp
export const isInStandaloneMode = () => {
  if ((window.matchMedia('(display-mode: standalone)').matches) || (window.navigator.standalone) || document.referrer.includes('android-app://')) {
    return true;
  } else {
    return false
  }
}

// 判断返回游戏链接是否有参数
export function hasQueryParams(url) {
  const [beforeHash] = url.split("#");
  return beforeHash.includes("?");
}

//获取所有url参数
export function GetUrlParam() {
  let url = document.location.toString();
  let arrObj = url.split("?");
  let params = Object.create(null)
  if (arrObj.length > 1) {
    arrObj = arrObj[1].split("&");
    arrObj.forEach(item => {
      item = item.split("=");
      params[item[0]] = item[1]
    })
  }
  return params;
}

// 日期格式化
export function parseTime(time, pattern) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = pattern || '{y}-{m}-{d}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    } else if (typeof time === 'string') {
      time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm), '');
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

// 存储带过期时间的数据
export function setWithExpiry(key, value, ttl) {
  const now = Date.now();
  const expiry = now + ttl; // ttl 单位：毫秒
  localStorage.setItem(key, JSON.stringify({
    value,
    expiry
  }));
}

// 获取数据并检查是否过期
export function getWithExpiry(key) {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) return null;

  const item = JSON.parse(itemStr);
  const now = Date.now();

  if (now > item.expiry) {
    localStorage.removeItem(key);
    return null;
  }

  return item.value;
}